/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable @typescript-eslint/no-namespace */ /* eslint-disable @typescript-eslint/prefer-namespace-keyword */ /* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint-disable @typescript-eslint/no-var-requires */ /* eslint-disable security/detect-non-literal-fs-filename */ /* eslint-disable node/no-deprecated-api */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import agentParser from 'ua-parser-js';
import paths from '@webpackConfig/paths';
import { Constants } from '@shared/utils/constants';
import { generateGuid } from '@shared/utils/appUtils';
import { getAppConfig } from '@shared/services/init/appConfig';
import { stringifyError } from '@shared/utils/errorUtils';
import { getStringQueryParam, scrubAcquisitionPayload } from '@server/Utils';
import { scrubHeaders } from '@shared/utils/httpClientUtil';
import stackTrace from 'stack-trace';
import { v4 as uuid } from 'uuid';
import { logger } from '@src/logger';
const fs = require('fs');
const sha256 = require('crypto-js/sha256');
const serverInstanceCorrelationId = process.env.serverInstanceCorrelationId || Constants.ReservedCorrelationIds.EmptyId;
const MethodTableMap = new Map([
    [
        'Debug',
        'Logs'
    ],
    [
        'Error',
        'Logs'
    ],
    [
        'LogHttpInboundRequestStart',
        'IncomingRequests'
    ],
    [
        'LogHttpInboundRequestEndWithSuccess',
        'IncomingRequests'
    ],
    [
        'LogHttpInboundRequestEndWithClientFailure',
        'IncomingRequests'
    ],
    [
        'LogHttpInboundRequestEndWithServerFailure',
        'IncomingRequests'
    ],
    [
        'LogHttpOutboundRequestStart',
        'OutgoingRequests'
    ],
    [
        'LogHttpOutboundRequestEndWithSuccess',
        'OutgoingRequests'
    ],
    [
        'LogHttpOutboundRequestEndWithClientFailure',
        'OutgoingRequests'
    ],
    [
        'LogHttpOutboundRequestEndWithServerFailure',
        'OutgoingRequests'
    ],
    [
        'LogAcquisitionInfo',
        'AcquisitionInfo'
    ],
    [
        'LogDbResourceOverUsage',
        'DbResourceOverUsage'
    ],
    [
        'LogUserFeedback',
        'UserFeedback'
    ],
    [
        'LogUserTelemetry',
        'UserTelemetry'
    ]
]);
const RequestsLogMethodToTaskName = {
    LogHttpInboundRequestStart: 'HttpInboundRequest',
    LogHttpInboundRequestEndWithSuccess: 'HttpInboundRequestEndWithSuccess',
    LogHttpInboundRequestEndWithClientFailure: 'HttpInboundRequestEndWithClientFailure',
    LogHttpInboundRequestEndWithServerFailure: 'HttpInboundRequestEndWithServerFailure',
    LogHttpOutboundRequestStart: 'HttpOutboundRequest',
    LogHttpOutboundRequestEndWithSuccess: 'HttpOutboundRequestEndWithSuccess',
    LogHttpOutboundRequestEndWithServerFailure: 'HttpOutboundRequestEndWithServerFailure',
    LogHttpOutboundRequestEndWithClientFailure: 'HttpOutboundRequestEndWithClientFailure'
};
(function(Logger) {
    function getCLRMethod(methodName) {
        return (args)=>{
            const { message = '' } = args, payload = _object_without_properties(args, [
                "message"
            ]);
            const collection = MethodTableMap.get(methodName);
            if (methodName === 'Error') {
                logger.serverLogger.error(message, _object_spread({
                    collection,
                    taskName: 'Error'
                }, payload));
                return;
            }
            // Deprecated
            if (collection === 'AcquisitionInfo' || collection === 'DbResourceOverUsage') {
                return;
            }
            if (collection === 'IncomingRequests' || collection === 'OutgoingRequests') {
                payload.taskName = RequestsLogMethodToTaskName[methodName];
            }
            if (methodName === 'Debug') {
                payload.taskName = 'Debug';
            }
            logger.serverLogger.info(message, _object_spread({
                collection
            }, payload));
        };
    }
    const LoggerDll = paths.dllLoggerPath;
    Logger.clrDebug = getCLRMethod('Debug');
    Logger.clrError = getCLRMethod('Error');
    Logger.clrLogUserTelemetry = getCLRMethod('LogUserTelemetry');
    const clrLogHttpInboundRequestStart = getCLRMethod('LogHttpInboundRequestStart');
    const clrLogHttpInboundRequestEndWithSuccess = getCLRMethod('LogHttpInboundRequestEndWithSuccess');
    const clrLogHttpInboundRequestEndWithClientFailure = getCLRMethod('LogHttpInboundRequestEndWithClientFailure');
    const clrLogHttpInboundRequestEndWithServerFailure = getCLRMethod('LogHttpInboundRequestEndWithServerFailure');
    const clrLogHttpOutboundRequestStart = getCLRMethod('LogHttpOutboundRequestStart');
    const clrLogHttpOutboundRequestEndWithSuccess = getCLRMethod('LogHttpOutboundRequestEndWithSuccess');
    const clrLogHttpOutboundRequestEndWithServerFailure = getCLRMethod('LogHttpOutboundRequestEndWithServerFailure');
    const clrLogHttpOutboundRequestEndWithClientFailure = getCLRMethod('LogHttpOutboundRequestEndWithClientFailure');
    const clrLogAcquisitionInfo = getCLRMethod('LogAcquisitionInfo');
    const clrLogDbResourceOverUsage = getCLRMethod('LogDbResourceOverUsage');
    const clrLogUserFeedback = getCLRMethod('LogUserFeedback');
    let logStreamData = null;
    let correlationIdToWatch = '';
    function startWatchingLog(correlationId) {
        correlationIdToWatch = correlationId;
        logStreamData = [];
        setTimeout(()=>{
            stopWatchingLog(correlationId);
        }, 60000); // Stop watching logs in 1 minute automatically in case we fail to stop watching log for any reasons.
    }
    // Call this function to start watch the log for the **session** based on the given correlation ID.
    // We use this function to immediately get the server side logs in the console for debugging purpose.
    Logger.startWatchingLog = startWatchingLog;
    function stopWatchingLog(correlationId) {
        if (correlationId === correlationIdToWatch) {
            correlationIdToWatch = '';
            logStreamData = null;
        }
    }
    Logger.stopWatchingLog = stopWatchingLog;
    function getLogStream() {
        return logStreamData;
    }
    Logger.getLogStream = getLogStream;
    function isWatchingLog(correlationId) {
        return correlationIdToWatch === correlationId;
    }
    Logger.isWatchingLog = isWatchingLog;
    function isLoggingEnabled(callbackFunction) {
        return fs.exists(LoggerDll, callbackFunction);
    }
    Logger.isLoggingEnabled = isLoggingEnabled;
    function writeToLogStream(correlationId, operation, message) {
        if (correlationId && logStreamData && correlationId === correlationIdToWatch) {
            const now = new Date();
            const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000); // Gets the UTC time.
            logStreamData.push({
                timeStamp: utc.toISOString(),
                operation: operation,
                message: message
            });
        }
    }
    // To be used by Node server side code Debug events
    function Debug(operationName, message, exception, additionalData) {
        // A JSON object in the exception causes edge to crash with stack overflow hence the check.
        let exceptionString = '';
        if (exception) {
            // Stringify also handles non JSON object such as raw strings, int, bools etc..
            exceptionString = JSON.stringify(exception);
        }
        const debugMessage = {
            requestId: additionalData && additionalData.requestId ? additionalData.requestId : uuid(),
            correlationId: additionalData && additionalData.correlationId ? additionalData.correlationId : serverInstanceCorrelationId,
            operationName: operationName.toString() || '',
            message: message.toString() || '',
            exception: exceptionString
        };
        Logger.clrDebug(debugMessage);
    }
    // Overload to debug without request and correlationId for server debugging
    function Information(operationName, message, exception, additionalData) {
        // A JSON object in the exception causes edge to crash with stack overflow hence the check.
        let exceptionString = '';
        if (exception) {
            // Stringify handles non JSON object such as raw strings, int, bools etc..
            exceptionString = JSON.stringify(exception);
        }
        let requestId = uuid();
        let correlationId = serverInstanceCorrelationId;
        if (additionalData) {
            if (additionalData.requestId) {
                requestId = additionalData.requestId;
            }
            if (additionalData.correlationId) {
                correlationId = additionalData.correlationId;
            }
        }
        const debugMessage = {
            requestId: requestId,
            correlationId: correlationId,
            operationName: operationName.toString() || '',
            message: message.toString() || '',
            exception: exceptionString
        };
        Logger.clrDebug(debugMessage);
    }
    function Exception(operationName, message, exception, otherInfo) {
        let requestId = uuid();
        let correlationId = serverInstanceCorrelationId;
        if (otherInfo) {
            requestId = otherInfo.requestId ? otherInfo.requestId : requestId;
            correlationId = otherInfo.correlationId ? otherInfo.correlationId : correlationId;
            if (otherInfo.request) {
                requestId = otherInfo.request.headers[Constants.Headers.RequestId] || requestId;
                correlationId = otherInfo.request.headers[Constants.Headers.CorrelationId] || correlationId;
            }
        }
        // A JSON object in the exception causes edge to crash with stack overflow hence the check.
        let exceptionString = '';
        if (exception) {
            // Stringify handles non JSON object such as raw strings, int, bools etc..
            exceptionString = JSON.stringify(exception, Object.getOwnPropertyNames(exception));
        }
        const errorMessage = {
            requestId: requestId,
            correlationId: correlationId,
            operationName: operationName.toString() || '',
            message: message.toString() || '',
            exception: exceptionString
        };
        Logger.clrError(errorMessage);
    }
    // To be used for Exception logging
    Logger.Exception = Exception;
    function LogFeedback(requestId, correlationId, event) {
        return _LogFeedback.apply(this, arguments);
    }
    function _LogFeedback() {
        _LogFeedback = _async_to_generator(function*(requestId, correlationId, event) {
            const message = {
                requestId: requestId || uuid(),
                correlationId: correlationId || serverInstanceCorrelationId,
                page: event.page ? event.page.toString() : '',
                clientTimestamp: event.clientTimestamp ? event.clientTimestamp.toString() : '',
                action: event.action ? event.action.toString() : '',
                actionModifier: event.actionModifier ? event.actionModifier.toString() : '',
                details: event.details ? typeof event.details === 'string' ? event.details.toString() : JSON.stringify(event.details) : '',
                hostType: event.hostType ? event.hostType.toString() : '',
                oid: event.oid ? event.oid.toString() : '',
                tid: event.tid ? event.tid.toString() : '',
                spzaId: event.spzaId ? event.spzaId.toString() : ''
            };
            const detailsAsJson = event.details ? typeof event.details === 'string' ? JSON.parse(event.details.toString()) : event.details : null;
            if (detailsAsJson) {
                message.details = detailsAsJson;
                sendFeedback(message);
            } else {
                sendFeedback(message);
            }
        });
        return _LogFeedback.apply(this, arguments);
    }
    Logger.LogFeedback = LogFeedback;
    function sendFeedback(message) {
        clrLogUserFeedback(message, function(error) {
            if (error) {
                Logger.Exception('LogFeedback', error, '');
            }
        });
    }
    function LogTelemetryEvent(requestId, correlationId, event) {
        // For all the error events we want to add a hash based on the error stack/message for making the kusto queries easier.
        if (event.actionModifier && event.actionModifier === Constants.Telemetry.ActionModifier.Error) {
            if (event.details) {
                event.details = JSON.stringify(getErrorDetailsWithHash(event.details));
            }
        }
        if (event.isFeedback) {
            LogFeedback(requestId, correlationId, event);
        } else {
            const message = {
                requestId: requestId || uuid(),
                correlationId: correlationId || serverInstanceCorrelationId,
                page: event.page ? event.page.toString() : '',
                clientTimestamp: event.clientTimestamp ? event.clientTimestamp.toString() : '',
                action: event.action ? event.action.toString() : '',
                actionModifier: event.actionModifier ? event.actionModifier.toString() : '',
                details: event.details ? typeof event.details === 'string' ? event.details.toString() : JSON.stringify(event.details) : '',
                appName: event.appName ? event.appName.toString() : '',
                product: event.product ? event.product.toString() : '',
                featureFlag: event.featureFlag ? event.featureFlag.toString() : '',
                hostType: event.hostType ? event.hostType.toString() : '',
                oid: event.oid ? 'true' : '',
                tid: event.tid ? event.tid.toString() : '',
                spzaId: event.spzaId ? event.spzaId.toString() : '',
                mshash: event.mshash ? event.mshash.toString() : ''
            };
            Logger.clrLogUserTelemetry(message, function(error) {
                if (error) {
                    Logger.Exception('LogTelemetry', error, '');
                }
            });
        }
    }
    // To be used by Browser via API route to log telemetry events
    Logger.LogTelemetryEvent = LogTelemetryEvent;
    function LogHttpInboundRequestStart(httpRequestContext) {
        clrLogHttpInboundRequestStart(httpRequestContext, function(error) {
            if (error) {
                Logger.Exception(httpRequestContext.operation, error, '', {
                    requestId: httpRequestContext.requestId,
                    correlationId: httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log incoming requests start
    Logger.LogHttpInboundRequestStart = LogHttpInboundRequestStart;
    function LogHttpInboundRequestEndWithSuccess(httpRequest) {
        clrLogHttpInboundRequestEndWithSuccess(httpRequest, function(error) {
            if (error) {
                Logger.Exception('LogHttpInboundRequestSuccess', error, '', {
                    requestId: httpRequest.httpRequestContext.requestId,
                    correlationId: httpRequest.httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log incoming requests end with success
    Logger.LogHttpInboundRequestEndWithSuccess = LogHttpInboundRequestEndWithSuccess;
    function LogHttpInboundRequestEndWithClientFailure(httpRequest) {
        clrLogHttpInboundRequestEndWithClientFailure(httpRequest, function(error) {
            if (error) {
                Logger.Exception('LogHttpInboundRequestEndWithClientFailure', error, '', {
                    requestId: httpRequest.httpRequestContext.requestId,
                    correlationId: httpRequest.httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log incoming requests end with client failure (4xx)
    Logger.LogHttpInboundRequestEndWithClientFailure = LogHttpInboundRequestEndWithClientFailure;
    function LogHttpInboundRequestEndWithServerFailure(httpRequest) {
        clrLogHttpInboundRequestEndWithServerFailure(httpRequest, function(error) {
            if (error) {
                Logger.Exception('LogHttpInboundRequestEndWithServerFailure', error, '', {
                    requestId: httpRequest.httpRequestContext.requestId,
                    correlationId: httpRequest.httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log incoming requests end with client failure (5xx)
    Logger.LogHttpInboundRequestEndWithServerFailure = LogHttpInboundRequestEndWithServerFailure;
    function LogHttpOutboundRequestStart(httpRequestContext) {
        const clonedRequest = cloneRequest({
            httpRequestContext
        });
        clrLogHttpOutboundRequestStart(clonedRequest, function(error) {
            if (error) {
                Logger.Exception(httpRequestContext.operation, error, '', {
                    requestId: httpRequestContext.requestId,
                    correlationid: httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log outgoing requests start
    Logger.LogHttpOutboundRequestStart = LogHttpOutboundRequestStart;
    function cloneRequest({ httpRequestContext: { requestId, correlationId, headers, operation, httpMethod, hostName, targetUri, apiVersion } }) {
        let parsedHeaders = headers || {};
        let i = 0;
        // in cases where the headers were stringified more than once
        while(typeof parsedHeaders === 'string' && i < 3){
            try {
                parsedHeaders = JSON.parse(parsedHeaders);
            } catch (error) {
                Logger.logDebugMessage(requestId, correlationId, 'cloneRequest', stringifyError(error));
                break;
            }
            // using i for sanity purposes.
            i += 1;
        }
        parsedHeaders = typeof parsedHeaders === 'string' ? {} : parsedHeaders;
        const clonedRequest = {
            requestId,
            correlationId,
            operation,
            httpMethod,
            hostName,
            targetUri,
            userAgent: parsedHeaders[Constants.Headers.XMSUserAgent] || '',
            clientIpAddress: '',
            apiVersion: apiVersion || '',
            contentLength: parsedHeaders['Content-Length'] || 0,
            headers: JSON.stringify(scrubHeaders(parsedHeaders))
        };
        return clonedRequest;
    }
    function LogHttpOutboundRequestEndWithSuccess(httpRequest) {
        const requestId = httpRequest.httpRequestContext.requestId;
        const correlationId = httpRequest.httpRequestContext.correlationId;
        clrLogHttpOutboundRequestEndWithSuccess(httpRequest, function(error) {
            if (error) {
                try {
                    const striginfyRequest = JSON.stringify(httpRequest);
                    Logger.Exception('LogHttpOutboundRequestEndWithSuccess', `error: ${error}. httpRequest: ${striginfyRequest}`, '', {
                        requestId,
                        correlationId
                    });
                } catch (stringifyError) {
                    Logger.Exception('LogHttpOutboundRequestEndWithSuccess', `error: ${error}. stringifyError: ${stringifyError}`, '', {
                        requestId,
                        correlationId
                    });
                }
            }
        });
    }
    // To be used by Node server side API to log outgoing requests end with success
    Logger.LogHttpOutboundRequestEndWithSuccess = LogHttpOutboundRequestEndWithSuccess;
    function LogHttpOutboundRequestEndWithServerFailure(httpRequest) {
        clrLogHttpOutboundRequestEndWithServerFailure(httpRequest, function(error) {
            if (error) {
                Logger.Exception('LogHttpOutboundRequestEndWithServerFailure', error, '', {
                    requestId: httpRequest.httpRequestContext.requestId,
                    correlationId: httpRequest.httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log outgoing requests end with client failure (4xx)
    Logger.LogHttpOutboundRequestEndWithServerFailure = LogHttpOutboundRequestEndWithServerFailure;
    function LogHttpOutboundRequestEndWithClientFailure(httpRequest) {
        clrLogHttpOutboundRequestEndWithClientFailure(httpRequest, function(error) {
            if (error) {
                Logger.Exception('LogHttpOutboundRequestEndWithClientFailure', error, '', {
                    requestId: httpRequest.httpRequestContext.requestId,
                    correlationId: httpRequest.httpRequestContext.correlationId
                });
            }
        });
    }
    // To be used by Node server side API to log outgoing requests end with server failure (5xx)
    Logger.LogHttpOutboundRequestEndWithClientFailure = LogHttpOutboundRequestEndWithClientFailure;
    function LogInboundRequestStart(request) {
        let requestId = uuid();
        let correlationId = serverInstanceCorrelationId;
        // request can be null for direct server calls, thus the empty guids
        if (request) {
            // default to empty guids for missing headers
            requestId = request.headers[Constants.Headers.RequestId] || requestId;
            correlationId = request.headers[Constants.Headers.CorrelationId] || getStringQueryParam(request, Constants.QueryStrings.CorrelationId) || correlationId;
        }
        try {
            const requestContext = {
                requestId: requestId,
                correlationId: correlationId,
                operation: request.url,
                httpMethod: request.method,
                hostName: request.hostname,
                targetUri: request.hostname + request.originalUrl,
                userAgent: request.headers[Constants.Headers.XMSUserAgent] || '',
                clientIpAddress: '',
                apiVersion: getStringQueryParam(request, 'version') || '',
                contentLength: request.headers['Content-Length'] || 0,
                headers: JSON.stringify(scrubHeaders(request.headers))
            };
            LogHttpInboundRequestStart(requestContext);
        } catch (exception) {
            Logger.Exception('LogHelper.LogInboundRequestStart', 'ExceptionLoggingRequest', exception);
        }
    }
    // Helper method to log all Inbound request starts
    Logger.LogInboundRequestStart = LogInboundRequestStart;
    function LogInboundRequestEnd(request, duration, httpStatus, errorMessage) {
        let requestId = uuid();
        let correlationId = serverInstanceCorrelationId;
        if (request) {
            requestId = request.headers[Constants.Headers.RequestId] || requestId;
            correlationId = request.headers[Constants.Headers.CorrelationId] || getStringQueryParam(request, Constants.QueryStrings.CorrelationId) || correlationId;
        }
        if (errorMessage) {
            // Stringify handles non JSON object such as raw strings, int, bools etc..
            errorMessage = JSON.stringify(errorMessage);
        }
        try {
            const requestContext = {
                requestId: requestId,
                correlationId: correlationId,
                operation: request.url,
                httpMethod: request.method,
                hostName: request.hostname,
                targetUri: request.hostname + request.url,
                userAgent: request.headers[Constants.Headers.XMSUserAgent] || '',
                clientIpAddress: '',
                apiVersion: getStringQueryParam(request, 'version') || '',
                contentLength: request.headers['Content-Length'] || 0,
                headers: JSON.stringify(scrubHeaders(request.headers))
            };
            const httpRequest = {
                httpRequestContext: requestContext,
                durationInMilliseconds: duration,
                httpStatusCode: httpStatus,
                errorMessage: errorMessage
            };
            if (httpStatus > 199 && httpStatus < 300) {
                LogHttpInboundRequestEndWithSuccess(httpRequest);
            } else if (httpStatus > 399 && httpStatus < 500) {
                LogHttpInboundRequestEndWithClientFailure(httpRequest);
            } else if (httpStatus > 499) {
                LogHttpInboundRequestEndWithServerFailure(httpRequest);
            }
        } catch (exception) {
            Logger.Exception('LogHelper.LogRequestEnd', 'ExceptionLoggingRequestEnd', exception);
        }
    }
    // Helper method to log all request end
    Logger.LogInboundRequestEnd = LogInboundRequestEnd;
    function LogOutboundRequestEnd(request, duration, httpStatus, errorMessage) {
        if (errorMessage) {
            // Stringify handles non JSON object such as raw strings, int, bools etc..
            errorMessage = JSON.stringify(errorMessage);
        }
        try {
            const clonedRequest = cloneRequest({
                httpRequestContext: request
            });
            const httpRequest = {
                httpRequestContext: clonedRequest,
                durationInMilliseconds: duration,
                httpStatusCode: httpStatus,
                errorMessage: errorMessage
            };
            if (httpStatus > 199 && httpStatus < 300) {
                LogHttpOutboundRequestEndWithSuccess(httpRequest);
            } else if (httpStatus > 399 && httpStatus < 500) {
                LogHttpOutboundRequestEndWithClientFailure(httpRequest);
            } else if (httpStatus > 499) {
                LogHttpOutboundRequestEndWithServerFailure(httpRequest);
            }
        } catch (exception) {
            Logger.Exception('LogHelper.LogOutboundRequestEnd', 'ExceptionLoggingRequestEnd', exception);
        }
    }
    // Helper for logging outbound request end, since we create the request context we dont need to extract it from the express request
    Logger.LogOutboundRequestEnd = LogOutboundRequestEnd;
    function LogDbResourceOverUsage(requestId, correlationId, requestCharge, latency, query) {
        try {
            const message = {
                requestId: requestId,
                correlationId: correlationId,
                requestCharge: requestCharge ? requestCharge.toString() : '-1',
                latency: latency ? latency.toString() : '-1',
                query: query
            };
            clrLogDbResourceOverUsage(message, function(error) {
                if (error) {
                    Logger.Exception('LogHelper.LogDbResourceOverUsage', 'LogDbResourceOverUsage', error);
                }
            });
        } catch (exception) {
            Logger.Exception('LoggerService.LogDbResourceOverUsage', 'Error logging db resource over usage', exception, {
                requestId: requestId,
                correlationId: correlationId
            });
        }
    }
    Logger.LogDbResourceOverUsage = LogDbResourceOverUsage;
    function LogAcquisitionInfo(requestId, correlationId, info, token) {
        try {
            info.userInfo.firstName = info.userInfo.firstName ? info.userInfo.firstName : token ? token.given_name : '';
            info.userInfo.lastName = info.userInfo.lastName ? info.userInfo.lastName : token ? token.family_name : '';
            info.userInfo.email = info.userInfo.email ? info.userInfo.email : token ? token.upn : '';
            info.userInfo.oid = info.userInfo.oid ? info.userInfo.oid : token ? token.oid : '';
            info.userInfo.tid = info.userInfo.tid ? info.userInfo.tid : token ? token.tid : '';
            Logger.LogAcquisitionInfoPayload(requestId, correlationId, info);
        } catch (exception) {
            Logger.Exception('Logger.LogAcquisitionInfo', 'Error logging acquisition info', exception, {
                requestId: requestId,
                correlationId: correlationId
            });
        }
    }
    // To be used by Browser via API route to log app acquisition info
    Logger.LogAcquisitionInfo = LogAcquisitionInfo;
    function LogAcquisitionInfoPayload(requestId, correlationId, info) {
        const message = {
            requestId: requestId,
            correlationId: correlationId,
            acquisitionInfoPayload: JSON.stringify(scrubAcquisitionPayload(info))
        };
        clrLogAcquisitionInfo(message, function(error) {
            if (error) {
                Logger.Exception('Logger.LogAcquisitionInfo', 'LogAcquisitionInfo', error);
            }
        });
    }
    // Separated these methods to call this one from tests to validate the arguments sent to this.
    Logger.LogAcquisitionInfoPayload = LogAcquisitionInfoPayload;
    function LogTelemetryEvents(requestId, correlationId, telemetrybatch, req) {
        try {
            var _telemetrybatch_TelemetryEvents;
            for(let i = 0; i < ((_telemetrybatch_TelemetryEvents = telemetrybatch.TelemetryEvents) === null || _telemetrybatch_TelemetryEvents === void 0 ? void 0 : _telemetrybatch_TelemetryEvents.length); i++){
                const telemetry = telemetrybatch.TelemetryEvents[`${i}`];
                try {
                    Logger.LogTelemetryEvent(requestId, correlationId, telemetryHelper(telemetry, req));
                } catch (exception) {
                    Logger.Exception('LoggerService.LogTelemetryEvents', 'Error logging telemetry row. Original telemtry row: ' + JSON.stringify(telemetry), exception, {
                        requestId,
                        correlationId
                    });
                }
            }
        } catch (exception) {
            Logger.Exception('LoggerService.LogTelemetryEvents', 'Error logging telemetry batch. Original telemtry batch: ' + JSON.stringify(telemetrybatch), exception, {
                requestId,
                correlationId
            });
        }
    }
    Logger.LogTelemetryEvents = LogTelemetryEvents;
    function ClientLogOutRequests(requestId, correlationId, telemetrybatch, request) {
        const userAgent = request.headers && (request.headers[Constants.Headers.XMSUserAgent] || request.headers[Constants.Headers.UserAgent]);
        const clientIp = request.headers && request.headers[Constants.Headers.XForwardedFor] || request.connection && request.connection.remoteAddress;
        try {
            var _telemetrybatch_TelemetryEvents;
            for(let i = 0; i < ((_telemetrybatch_TelemetryEvents = telemetrybatch.TelemetryEvents) === null || _telemetrybatch_TelemetryEvents === void 0 ? void 0 : _telemetrybatch_TelemetryEvents.length); i++){
                const telemetry = telemetrybatch.TelemetryEvents[`${i}`];
                try {
                    logOutRequest(telemetry, userAgent, clientIp);
                } catch (exception) {
                    Logger.Exception('LoggerService.ClientLogOutRequests', 'Error logging telemetry row. Original telemtry row: ' + JSON.stringify(telemetry), exception, {
                        requestId,
                        correlationId
                    });
                }
            }
        } catch (exception) {
            Logger.Exception('LoggerService.ClientLogOutRequests', 'Error logging telemetry batch. Original telemtry batch: ' + JSON.stringify(telemetrybatch), exception, {
                requestId,
                correlationId
            });
        }
    }
    // Used for client
    Logger.ClientLogOutRequests = ClientLogOutRequests;
    function ServerLogOutRequest(telemetry) {
        const userAgent = getAppConfig('httpUserAgent');
        const clientIp = getAppConfig('serverIp');
        try {
            logOutRequest(telemetry, userAgent, clientIp);
        } catch (exception) {
            Logger.Exception('LoggerService.ServerLogOutRequest', 'Error logging telemetry row. Original telemtry row: ' + JSON.stringify(telemetry), exception);
        }
    }
    // Used for server
    Logger.ServerLogOutRequest = ServerLogOutRequest;
    function logServerTelemetryEvent(payload, correlationId, requestId) {
        const event = {
            page: payload.page ? payload.page : '',
            action: payload.action ? payload.action : '',
            actionModifier: payload.actionModifier ? payload.actionModifier : '',
            clientTimestamp: new Date().toISOString(),
            details: payload.details ? payload.details : '',
            isFeedback: payload.isFeedback
        };
        const outEvents = {
            TelemetryEvents: [
                event
            ]
        };
        requestId = requestId || generateGuid();
        LogTelemetryEvents(requestId, correlationId, outEvents);
    }
    Logger.logServerTelemetryEvent = logServerTelemetryEvent;
    function errorToConsole(message) {
        if (process.env.siteEnvironment !== 'prod') {
            console.error(message);
        }
    }
    function logDebugMessage(requestId, correlationId, operation, message) {
        Debug(operation, message, '', {
            requestId: requestId,
            correlationId: correlationId
        });
        writeToLogStream(correlationId, operation, message);
    }
    Logger.logDebugMessage = logDebugMessage;
    function logErrorMessage(requestId, correlationId, operation, message) {
        Exception(operation, message, '', {
            requestId: requestId,
            correlationId: correlationId
        });
    }
    Logger.logErrorMessage = logErrorMessage;
    function logInfoMessage(operation, message, exception, additionalData) {
        Information(operation, message, exception, additionalData);
        writeToLogStream(additionalData ? additionalData.correlationId : serverInstanceCorrelationId, operation, message);
    }
    Logger.logInfoMessage = logInfoMessage;
    function logError(operation, message, err, additionalData, correlationId) {
        const trace = stackTrace.parse(err);
        Logger.Exception(operation, message + ':' + stringifyError(err), trace, additionalData);
        const payload = {
            page: 'Error Page (Server)',
            action: 'Page Load',
            actionModifier: Constants.Telemetry.ActionModifier.Error,
            details: '[Error Trace] ' + stringifyError(err) + '   Stack: ' + JSON.stringify(trace)
        };
        correlationId = correlationId || (additionalData && additionalData.correlationId ? additionalData.correlationId : serverInstanceCorrelationId);
        const requestId = additionalData && additionalData.requestId;
        logServerTelemetryEvent(payload, correlationId, requestId);
        writeToLogStream(correlationId, operation, message);
    }
    Logger.logError = logError;
    // Creates a hash based on the error stack or on the error message and returns the JSON with the hash
    function getErrorDetailsWithHash(errorMessage) {
        const stringErrorMessage = typeof errorMessage === 'string' ? errorMessage : stringifyError(errorMessage);
        const errorStack = stringErrorMessage.split('Stack:');
        const hash = errorStack.length > 0 ? sha256(errorStack[1]) : sha256(errorMessage);
        const errorDetails = {
            message: stringErrorMessage,
            errorHash: hash.toString()
        };
        return errorDetails;
    }
    const parseEventDetails = (event)=>{
        try {
            return JSON.parse(event.details);
        } catch (e) {
            return {
                details: event.details
            }; // incase the details is not a valid JSON
        }
    };
    function telemetryHelper(event, req) {
        if (event.action === Constants.Telemetry.Action.UserSettings) {
            const clientIP = req.headers[Constants.Headers.XForwardedFor] || req.connection.remoteAddress;
            const userAgent = req.headers[Constants.Headers.XMSUserAgent] || req.headers[Constants.Headers.UserAgent];
            const parsedUserAgent = userAgent && agentParser(userAgent);
            event.details = JSON.stringify(_object_spread(_object_spread_props(_object_spread({}, parseEventDetails(event), parsedUserAgent), {
                clientIP
            }), scrubHeaders(req.headers)));
        }
        return event;
    }
    function logOutRequest(telemetry, userAgent, clientIp) {
        if (telemetry.taskName === Constants.Telemetry.OutRequest.Start) {
            Logger.LogHttpOutboundRequestStart(outRequestStartsTelemetryHelper(telemetry, userAgent, clientIp));
        } else {
            const telemetryEvent = outRequestEndsTelemetryHelper(telemetry, userAgent, clientIp);
            if (telemetry.taskName === Constants.Telemetry.OutRequest.EndWithSuccess) {
                Logger.LogHttpOutboundRequestEndWithSuccess(telemetryEvent);
            } else if (telemetry.taskName === Constants.Telemetry.OutRequest.EndWithClientError) {
                Logger.LogHttpOutboundRequestEndWithClientFailure(telemetryEvent);
            } else if (telemetry.taskName === Constants.Telemetry.OutRequest.EndWithServerError) {
                Logger.LogHttpOutboundRequestEndWithServerFailure(telemetryEvent);
            }
        }
    }
    function outRequestTelemetryHelper(event, userAgent, clientIpAddress) {
        const requestContext = {
            requestId: event.requestId,
            correlationId: event.correlationId,
            operation: event.operation,
            httpMethod: event.httpMethod,
            hostName: event.hostName,
            targetUri: event.targetUri,
            userAgent,
            clientIpAddress,
            apiVersion: '',
            contentLength: 0,
            headers: ''
        };
        return requestContext;
    }
    function outRequestStartsTelemetryHelper(event, userAgent, clientIpAddress) {
        const httpRequestContext = outRequestTelemetryHelper(event, userAgent, clientIpAddress);
        httpRequestContext.headers = event.requestHeaders;
        return httpRequestContext;
    }
    function outRequestEndsTelemetryHelper(event, userAgent, clientIpAddress) {
        const httpRequestContext = outRequestTelemetryHelper(event, userAgent, clientIpAddress);
        httpRequestContext.contentLength = event.contentLength;
        httpRequestContext.headers = event.responseHeaders;
        const request = {
            httpRequestContext,
            errorMessage: event.errorMessage,
            durationInMilliseconds: event.durationInMilliseconds,
            httpStatusCode: event.httpStatusCode
        };
        return request;
    }
    Logger.LogHttpOutboundRequestEnds = {
        [Constants.Telemetry.OutRequest.EndWithSuccess]: Logger.LogHttpOutboundRequestEndWithSuccess,
        [Constants.Telemetry.OutRequest.EndWithClientError]: Logger.LogHttpOutboundRequestEndWithClientFailure,
        [Constants.Telemetry.OutRequest.EndWithServerError]: Logger.LogHttpOutboundRequestEndWithServerFailure
    };
})(Logger || (Logger = {}));
export var Logger;
